import MenuCard, { MenuCardMobile } from "@/components/MenuCard";

export default function MenuSection({ category, items, onAddToBasket, viewOnly = false, locationSlug = null, accessCode = null }) {
  if (!category || items.length === 0) return null;

  return (
    <section
      id={`category-${category.key}`}
      data-category-key={category.key}
      className="mb-8 animate-fade-in scroll-mt-[140px]"
    >
      {/* Category Header */}
      <div className="flex items-center gap-3 mb-3">
        <div 
          className="w-9 h-9 rounded-lg flex items-center justify-center text-white flex-shrink-0"
          style={{ backgroundColor: category.color }}
        >
          {category.image_base64 ? (
            <img 
              src={category.image_base64} 
              alt="" 
              className="w-full h-full rounded-lg object-cover"
            />
          ) : (
            <span className="text-base">🍽️</span>
          )}
        </div>
        <div>
          <h2 className="text-lg sm:text-xl font-bold" style={{ color: category.color }}>{category.label}</h2>
          {category.description && (
            <p className="text-xs sm:text-sm text-gray-500">{category.description}</p>
          )}
        </div>
      </div>

      {/* Mobile Grid - 2 columns */}
      <div className="grid grid-cols-2 gap-2 sm:hidden">
        {items.map((item) => (
          <MenuCardMobile
            key={item.id}
            item={item}
            categoryColor={category.color}
            onAddToBasket={() => onAddToBasket?.(item)}
            viewOnly={viewOnly}
            locationSlug={locationSlug}
            accessCode={accessCode}
          />
        ))}
      </div>

      {/* Desktop/Tablet Grid - 2-4 columns */}
      <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {items.map((item) => (
          <MenuCard
            key={item.id}
            item={item}
            categoryColor={category.color}
            onAddToBasket={() => onAddToBasket?.(item)}
            viewOnly={viewOnly}
            locationSlug={locationSlug}
            accessCode={accessCode}
          />
        ))}
      </div>
    </section>
  );
}
